import { render, staticRenderFns } from "./ReporteInasistencias.vue?vue&type=template&id=b684c1f8&scoped=true"
import script from "./ReporteInasistencias.vue?vue&type=script&lang=js"
export * from "./ReporteInasistencias.vue?vue&type=script&lang=js"
import style0 from "./ReporteInasistencias.vue?vue&type=style&index=0&id=b684c1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b684c1f8",
  null
  
)

export default component.exports